import { zoologyNum } from '@/utils/api/dashboard'
const store = {
  namespaced: true,
  state: () => {
    return {
      numMap: {
        agreementsNum: 0,
        canQuoteRfqNum: 0,
        totalQuoteNum: 0,
      },
      tableRowIndex:undefined
    }
  },
  mutations: {
    SET_ZOOLOGYNUM(state, payload) {
      state.numMap = payload
    },
    SET_TABLEROWINDEX(state,payload){
      state.tableRowIndex = payload
    }
  },
  actions: {
    async getZhenyunLevelLength({ commit }) {
      try {
        const res = await zoologyNum()
        if (res.rspResult.bizCode === 200) {
          commit('SET_ZOOLOGYNUM', res.data)
          return res.data
        }
        throw new Error('请求失败')
      } catch (error) {
        throw error
      }
    },
  },
}

export default store
